import React from "react";
import {appCtx, isTalDemo, useFetchData} from "../app/AppContext";
import {DashCardDivider} from "../app/CommonUIComponenets";
import {ReactComponent as GytpolLogoWhite} from '../img/GYTPOL-logo-white.svg'
import {ReactComponent as GytpolLogoColor} from '../img/GYTPOL-logo-color.svg'
import {useUser} from "../app/UseAppData";
import {checkRoleAdmin} from "../app/CommonUIData";
import {findNotifPath, MenuTree} from "../tools/UIControls";
import {useInputChange} from "../tools/Inputs";
import {useColorModeTheme} from "../tools/CommonReact";

export function SideBar({menu, helpActions}) {
    const {user} = useUser();
    const {curTheme} = useColorModeTheme();
    const {inp, onChange} = useInputChange({help: ""});
    const isAdmin = checkRoleAdmin(user?.perms?.[0]);
    const userPermittedMenu = filterMenuByPerms(menu, isAdmin);
    
    const {rsp: rspNotifs, refresh} = useFetchData({
        api: "/api/v2/notif_get-totals",            // TODO: Add socket!
        alt: {data: [{type: "clientLog", count: 2}]}
    });

    const notifPaths = rspNotifs?.data.map(nt => findNotifPath(menu, nt.type, nt.count));

    return (
        <div className="flex-none sticky top-0 w-60 px-4 z-10 shadow-lg py-5 overflow-y-scroll scrollbar-none h-screen flex flex-col bg-bg3">
            {React.createElement(curTheme !== "dark"? GytpolLogoColor : GytpolLogoWhite, {
                className: "shrink-0 fill-title w-4/5 self-center mb-6 cursor-pointer",
                onClick: e => appCtx.nav.to("/miscon_overview", {}, {isReset: true})
            })}
            <MenuTree menuArr={userPermittedMenu} field="page" notifsPaths={notifPaths} value={appCtx.nav.getCurPath()}
                      className="text-icon" onSelect={(k => appCtx.nav.to(k, {}, {isReset: true}))} subMenuOpenPred={(subOpen, path) => subOpen?.startsWith(path)}/>
            <DashCardDivider/>
            <div className="grow"/>
            {isTalDemo && helpActions &&
                <MenuTree menuArr={helpActions} field="help" onChange={onChange} value={inp.help}
                          className="shadow-md w-48 bottom-4 rounded-lg bg-bg1 text-title" openAbove depth={1}/>}
        </div>
    );
}


function filterMenuByPerms(menu, isAdmin) {
    return menu.map(item => (!item.perms || (item.perms?.admin && isAdmin)) && ({
        ...item,
        ...(item.subMenu && {
            subMenu: filterMenuByPerms(item.subMenu, isAdmin)
        })
    }));
}